<app-memory-viewer></app-memory-viewer>
<app-audio-viewer></app-audio-viewer>
<app-file-uploader></app-file-uploader>
<app-user-auth></app-user-auth>
<div id="game">
  <!-- <div style="width:0px; height:0.1px">Refresh the page for adventure</div> -->
</div>